import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Anchor, Rocket, BookOpen, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export const LaunchKitWelcomeBanner = () => {
  return (
    <Card className="bg-gradient-to-br from-primary/10 via-primary/5 to-background border-primary/20">
      <CardContent className="pt-6 pb-8">
        <div className="flex flex-col items-center text-center max-w-2xl mx-auto">
          <div className="p-3 rounded-full bg-primary/10 mb-4">
            <Anchor className="h-8 w-8 text-primary" />
          </div>
          
          <h2 className="text-2xl font-bold text-foreground mb-2">
            Welcome to HostCaptain! 🎉
          </h2>
          <p className="text-muted-foreground mb-6">
            We're here to help you grow your Turo business and simplify your hosting journey.
            Whether you're just getting started or looking to scale, we've got your back.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full mb-6">
            <div className="flex flex-col items-center p-4 rounded-lg bg-background/50 border">
              <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10 mb-3">
                <BookOpen className="h-5 w-5 text-primary" />
              </div>
              <h3 className="font-semibold text-sm mb-1">Learn the Basics</h3>
              <p className="text-xs text-muted-foreground text-center">
                Start with our free guides to get your first car listed
              </p>
            </div>
            
            <div className="flex flex-col items-center p-4 rounded-lg bg-background/50 border">
              <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10 mb-3">
                <Rocket className="h-5 w-5 text-primary" />
              </div>
              <h3 className="font-semibold text-sm mb-1">Launch with Confidence</h3>
              <p className="text-xs text-muted-foreground text-center">
                Follow proven strategies from successful hosts
              </p>
            </div>
            
            <div className="flex flex-col items-center p-4 rounded-lg bg-background/50 border">
              <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10 mb-3">
                <Anchor className="h-5 w-5 text-primary" />
              </div>
              <h3 className="font-semibold text-sm mb-1">Grow Your Fleet</h3>
              <p className="text-xs text-muted-foreground text-center">
                Scale up with advanced tools and insights
              </p>
            </div>
          </div>

          <p className="text-sm text-muted-foreground mb-4">
            Ready to dive in? Start with our beginner guides below. 👇
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
